export const languageStringsAdmin = {
  title: "Klienci",
  pricingPeriod: {
    monthly: "Miesięczny",
    yearly: "Roczny",
  },
  table: {
    email: "Email",
    fullName: "Pełna nazwa",
    accountType: "Typ konta",
    websites: "Strony internetowe",
    campaigns: "Kampanie",
    subscription: "Subskrypcja",
    takeControl: "Przejmij kontrolę",
    loginButton: "Zaloguj się",
    noSubscription: "-------",
  },
  tools: {
    button: "Narzędzia administratora",
    modalTitle: "Narzędzia administratora",
    title: "Narzędzia administratora",
    clearCache: "Wyczyść pamięć podręczną",
    error: "Błąd podczas wykonywania akcji",
    clearGoogleReviewsCache: {
      title: "Wyczyść pamięć podręczną recenzji Google",
      description:
        "Wyczyść wszystkie dane z pamięci podręcznej recenzji Google dla wszystkich stron. Recenzje zostaną ponownie pobrane przy następnym żądaniu w języku skonfigurowanym dla każdej witryny.",
      success: "Pamięć podręczna recenzji Google została pomyślnie wyczyszczona",
    },
  },
  errorLogs: {
    button: "Dzienniki błędów",
    title: "Dzienniki błędów (frontend)",
    empty: "Brak zarejestrowanych błędów.",
  },
};
